import Item from './item';
import Email from './email';
import Password from './password';
import Phone from './phone';
import DateOfBirth from './dateOfBirth';

export const Inputs = {
    Item,
    Email,
    Phone,
    Password,
    DateOfBirth
}

export default Inputs


// WEBPACK FOOTER //
// ./src/helper/form/input/index.js